import * as React from 'react';
import Home from './pages/Home';

function App() {
  return (
    <div className="App bg-[#F9FBFD]">
      <Home />
    </div>
  );
}

export default App;
